import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   subscription: {},
   subscriptionResponse: {},
   subscriptions: [],
   openForm: false,
   createLoading: false,
   getLoading: false,
};

const subscriptions = createSlice({
   name: "subscriptions",
   initialState,
   reducers: {
      setSubscriptionResponse(state, action) {
         state.subscriptionResponse = action.payload;
      },
      setSingleSubscription(state, action) {
         state.subscription = action.payload;
      },
      setOpenForm(state, action) {
         state.openForm = action.payload;
      },
      setCreateLoading(state, action) {
         state.createLoading = action.payload;
      },
      setGetLoading(state, action) {
         state.getLoading = action.payload;
      },
   },
});

export const subscriptionActions = subscriptions.actions;
export const subscriptionReducer = subscriptions.reducer;
